import React from "react";

export default function OrderDetails({ order }) {
  const items = order?.items || [];

  // Delivery_address might be an object (recommended from backend)
  // or a JSON string (old orders). Handle both.
  const addrRaw = order?.delivery_address;

  let addrObj = null;

  if (addrRaw && typeof addrRaw === "object") {
    addrObj = addrRaw;
  } else if (addrRaw && typeof addrRaw === "string") {
    try {
      const parsed = JSON.parse(addrRaw);
      if (parsed && typeof parsed === "object") addrObj = parsed;
    } catch (e) {
      addrObj = null;
    }
  }

  const formattedAddress = addrObj
    ? [addrObj.line1, addrObj.line2, addrObj.city].filter(Boolean).join(", ")
    : "";

  return (
    <div className="profile-order-items expanded-background">
      {/* Order Info */}
      <div className="profile-order-info">
        {order?.customer_phone && (
          <p>
            <strong>Phone No:</strong> {order.customer_phone}
          </p>
        )}

        {order?.customer_email && (
          <p>
            <strong>Email:</strong> {order.customer_email}
          </p>
        )}

        {order?.order_type === "Pick Up" && (
          <>
            {order?.pickup_date && (
              <p>
                <strong>Pick Up Date:</strong>{" "}
                {new Date(order.pickup_date).toLocaleDateString("en-GB", {
                  weekday: "long",
                  day: "numeric",
                  month: "short",
                  year: "numeric",
                })}
              </p>
            )}

            {order?.pickup_time && (
              <p>
                <strong>Pick Up Time:</strong>{" "}
                {new Date(`1970-01-01T${order.pickup_time}`).toLocaleTimeString(
                  "en-GB",
                  {
                    hour: "numeric",
                    minute: "2-digit",
                    hour12: true,
                  },
                )}
              </p>
            )}
          </>
        )}

        {order?.order_type === "Delivery" && (
          <>
            {(addrObj || addrRaw) && (
              <p>
                <strong>Delivery Address:</strong>{" "}
                {formattedAddress || String(addrRaw)}
              </p>
            )}

            {order?.postcode && (
              <p>
                <strong>Postcode:</strong> {order.postcode}
              </p>
            )}

            {order?.delivery_fee != null && (
              <p>
                <strong>Delivery Fee:</strong> £
                {Number(order.delivery_fee || 0).toFixed(2)}
              </p>
            )}
          </>
        )}
      </div>

      <hr />

      {/* Items */}
      {items.map((item) => {
        const optional = item?.selectedOptionalOptions || [];

        const optionTotal = optional.reduce(
          (sum, opt) =>
            sum + Number(opt.price || 0) * Number(opt.quantity || 0),
          0,
        );

        const qty = Number(item?.quantity || 1);
        const basePrice = Number(item?.base_price || 0);
        const reqPrice = Number(item?.required_option_price || 0);

        const itemTotal = (basePrice + reqPrice + optionTotal) * qty;

        return (
          <div key={item.id} className="profile-order-item">
            <div className="profile-order-item-header">
              <span className="profile-order-item-title">
                {item.name}
                {basePrice > 0 && <> (£{basePrice.toFixed(2)})</>}
              </span>
            </div>

            {/* Required Option */}
            {item.required_option_id && (
              <div className="profile-order-item-option">
                <ul>
                  <li>
                    {item.required_option_name}
                    {reqPrice > 0 && <> (£{reqPrice.toFixed(2)})</>}
                  </li>
                </ul>
              </div>
            )}

            {/* Optional Options */}
            {optional.length > 0 && (
              <div className="profile-order-item-option">
                <strong>Optional:</strong>
                <ul>
                  {optional.map((opt, idx) => {
                    const optPrice = Number(opt.price || 0);
                    const optQty = Number(opt.quantity || 0);
                    return (
                      <li key={idx}>
                        {opt.name} x {optQty}
                        {optPrice > 0 && (
                          <> (£{(optPrice * optQty).toFixed(2)})</>
                        )}
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}

            <div className="profile-order-item-total-wrapper">
              <span className="profile-order-item-total-text">
                x {qty} = £{itemTotal.toFixed(2)}
              </span>
            </div>

            <hr className="profile-order-item-divider" />
          </div>
        );
      })}

      {order?.service_charge != null && Number(order.service_charge) > 0 && (
        <p>
          <strong>Service Charge:</strong> £
          {Number(order.service_charge || 0).toFixed(2)}
        </p>
      )}

      {order?.notes?.trim() && (
        <p className="profile-order-notes">
          <strong>Notes:</strong> {order.notes}
        </p>
      )}
    </div>
  );
}
